import { useQuery } from "@tanstack/react-query";

import { Status } from "@seneca/surveys-service-types";

import { getClient } from "services";

import { isSignedIn as getIsSignedIn } from "seneca-common/features/user/state";
import { useSelector } from "seneca-common/utils/hooks/selectors";

import { useIsPlurallApp } from "features/plurall";

import { SURVEYS_KEY } from "../consts";

export default function useFetchAllActiveSurveys() {
  const isSignedIn = useSelector(getIsSignedIn);
  const isPlurallApp = useIsPlurallApp();

  return useQuery(
    [SURVEYS_KEY],
    async () =>
      getClient("surveysService").fetchAllSurveys({ status: Status.active }),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: isSignedIn && !isPlurallApp
    }
  );
}
